/* ============================================================================
   ROG — Format des cellules de la galerie « Vos photos et vidéos ».
   15/08/2026.

   La grille pose un format 2:3 à toutes les cellules. Les médias en paysage y
   perdraient jusqu'à 70 % de leur largeur : on leur donne deux colonnes et un
   format 3:2. Encore faut-il savoir lesquels le sont — ce n'est écrit nulle
   part dans le gabarit, et Liquid ne connaît pas les dimensions d'une vidéo.

   On mesure donc le média lui-même, une fois ses métadonnées connues, et on
   pose `data-format="large"` sur la cellule. Tant que la mesure n'a pas eu
   lieu, la cellule garde le format 2:3 : rien ne saute, rien ne clignote.
   ========================================================================= */
(function () {
  var items = document.querySelectorAll('.rog-masonry-item');
  if (!items.length) return;

  var SEUIL = 1.1; /* au-delà, le média est plus large que haut */

  function classer(item, largeur, hauteur) {
    if (!largeur || !hauteur) return;
    if (largeur / hauteur > SEUIL) item.dataset.format = 'large';
    else item.removeAttribute('data-format');
  }

  function traiter(item) {
    var v = item.querySelector('video');
    if (v) {
      if (v.videoWidth) { classer(item, v.videoWidth, v.videoHeight); return; }
      v.addEventListener('loadedmetadata', function () {
        classer(item, v.videoWidth, v.videoHeight);
      }, { once: true });
      /* `metadata` suffit : on ne télécharge pas la vidéo pour la mesurer. */
      if (v.preload === 'none') { v.preload = 'metadata'; }
      return;
    }
    var i = item.querySelector('img');
    if (!i) return;
    if (i.naturalWidth) { classer(item, i.naturalWidth, i.naturalHeight); return; }

    /* L'image est en chargement paresseux : tant qu'elle n'entre pas dans
       l'écran, `naturalWidth` reste à zéro et son format est inconnu — la
       cellule resterait alors en 2:3 même pour un paysage. On mesure donc sur
       une vignette de 40 px demandée à part : le CDN la renvoie en quelques
       octets, et le format est connu tout de suite. Même technique que sur la
       carte d'image de la fiche produit. */
    var url = i.getAttribute('src') || i.currentSrc || i.src;
    if (!url) return;
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    var sonde = new Image();
    sonde.onload = function () { classer(item, sonde.naturalWidth, sonde.naturalHeight); };
    sonde.onerror = function () {};
    sonde.src = url.split('?')[0].replace(/_\d+x(\.[a-z]+)$/i, '$1') + '?width=40';
  }

  function tout() {
    for (var n = 0; n < items.length; n++) traiter(items[n]);
  }

  if (window.requestIdleCallback) window.requestIdleCallback(tout, { timeout: 1200 });
  else window.setTimeout(tout, 300);
})();
